import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, ChangeDetectorRef} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule, NgForm } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';

import { ItemModel, MenuEventArgs, DropDownButtonComponent, OpenCloseMenuEventArgs  } from '@syncfusion/ej2-angular-splitbuttons';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { SubjectInvoiceItem } from './../../../shared/models/subjectInvoiceItem.model';
import { SubjectWorkOrderItem } from './../../../shared/models/subjectWorkOrderItem.model';
import { SubjectWorkOrder } from './../../../shared/models/subjectWorkOrder.model';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';


@Component({
  selector: 'app-create-work-order-widget',
  templateUrl: './create-work-order-widget.component.html',
  styleUrls: ['./create-work-order-widget.component.css']
})
export class CreateWorkOrderWidgetComponent implements OnInit, OnChanges {


     // setup as observable?
     @Input() item_id?; // impliments on changes.
     @Input() item_data?; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full
  
     job: any;
     @Input() job_id; 
     @Input() subject_id; 
     @Input() subject_number?;
     @Input() job_number?;
   
     @Input() agent_id;
   
    @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
 //   @Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();

     invoice_model: SubjectInvoice = new SubjectInvoice();
     invoice_item_model: any = SubjectInvoiceItem;

      work_order_model: SubjectWorkOrder = new SubjectWorkOrder();
      work_order_item_model: SubjectWorkOrderItem;

  brand_invoice_id: any;
  brand: any;
  invoice_brand: any;
  subject_billing_items: any;
  owner_brand: any;

  // holding array items;
  invoiceItemsList: any = [];
  invoiceItem: any = [];
  workOrderItemsList: any = [];
  workOrderItem: any = [];

  isShowEdit = false ; // hidden by default]
  isShow; // hidden by default
  invoice_total: any;
  invoice_tax: number;
  invoice_subtotal: number;
  invoice_job_type_id: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;

  public today = Date.now();
  modalRef: BsModalRef;
  invoice_status_all: any;
  invoice_payment_status_all: any;
  invoice_communication_status_all: any;
  valueDatePickerDate: Date;
  expanded = false;
  new_invoice_id: any;
  returned_invoice_id: any;
  subject: any;
  subject_work_order_items: any;
  subject_cost_items: any;
  work_order_total: any;
  work_order_tax: any;
  work_order_subtotal: any;
  work_order_status_all: any;
  work_order_payment_status_all: any;
  work_order_communication_status_all: any;
  new_work_order_id: any;
  returned_work_order_id: any;
  assignedBrandList: any;
  agent_brand: any;
  agent_full_name: any;

  

  @ViewChild('dialog')
  public alertDialog: DialogComponent;
  @ViewChild('dropdownbutton')
  public dropdownbutton: DropDownButtonComponent;


   // access the template form
   @ViewChild('invoiceForm') invoiceForm: NgForm;
  selected_agent_id: any;
  dateFormat: string;
  valueDatePickerDate_due: Date;
  
    constructor(
      private http: HttpClient, private _demoService: DemoService,
      private route: ActivatedRoute, public toastr: HotToastService,
       vcr: ViewContainerRef, private router: Router,
       public HttpClient:HttpClient,
       private fileUploader: FileUploaderService,
       private _mysqlService: MysqlService,
       private modalService: BsModalService,
       public datepipe: DatePipe,
       public gfunc: GlobalFunctionsService,
       private cdr:ChangeDetectorRef // allows for change detection once pushed data to an array
    ) {
       // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

   //   this.toastr.setRootViewContainerRef(vcr);
// Date picker date format
  //   this.valueDatePickerDate = new Date(this.today);
      // automically set the new dat 30 dyas form today
// ::@https://stackoverflow.com/questions/44827066/add-30-days-to-a-current-date-js
const date = new Date(); // Now

// DEC 2022 Update Default to 14 Days
const new_date = date.setDate(date.getDate() + 14);
// const new_date = date.setDate(date.getDate() + 30);

// invoice_model.due_date = this.datepipe.transform(new_date, 'dd-MM-yy');
// this.dateFormat = 'dd/MM/yyyy hh:mm a'; // standard date format
this.dateFormat = 'd/M/y h:m a z'; // standard date format
// invoice_model.due_date = this.datepipe.transform(new_date, this.dateFormat);


   //   this.toastr.setRootViewContainerRef(vcr);
// Date picker date format
   this.valueDatePickerDate = new Date(this.today);
   this.valueDatePickerDate_due = new Date(new_date);




     }
  
     // check for changes. to load data.
     ngOnChanges(changes) {

      this.getInvoiceAgentBrand(this.agent_id); // agent ID is set from the @inputs
      this.getSubjectAgentBrandsAssigned(this.subject_id);

  // this.invoice_model = new SubjectInvoice();
  // this.invoice_item_model = new SubjectInvoiceItem();

  this.work_order_item_model = new SubjectWorkOrderItem();
  
 // this.getSubjectBillingItems(this.subject_id);
  this.getSubjectCostItems(this.subject_id);
  this.getJobSubject(this.subject_id);
  this.getJob(this.job_id);

  // this.getInvoiceStatusAll();
  // this.getInvoicePaymentStatusAll();
  // this.getInvoiceCommunicationStatusAll();
  this.getWorkOrderStatusAll();
  this.getWorkOrderPaymentStatusAll();
  this.getWorkOrderCommunicationStatusAll();






if (changes.item_id) {
        // deal with asynchronous Observable result
      //  this.job_id = changes.item_id.currentValue;
        // this.getJob(this.job_id);
      }
    }
  
  
    ngOnInit() {
    }
  
    // Functions






    getJobSubject(subject_id) {
      this._demoService.getJobSubject(subject_id).subscribe(
        data => { this.subject = data;
          let res = data[0];
          this.subject_number = res.subject_number;
         // this.job_number = res.job_id + '.1'; // made up
         // console.log("Done loadng USER");

// NEED TO GET THE AGENTS>


        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }
 




  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
       data => { this.job = data;
        let res = data[0];
        // Run the job data queries.
      this.brand_invoice_id =  res.brand_invoice_id;
      this.invoice_job_type_id = res.job_type_id;
      this.getInvoiceBrand(res.brand_invoice_id);
      this.getOwnerBrand(94);

// setup the invoice holding data (this did NOT load the form data without running a ngfor statement)
  // Setup the SubjectInvoice
  // this.invoiceItem.push({
  //   invoice_number: this.subject_number,
  //   job_id: this.job_id,
  //   to_brand_id: this.brand_invoice_id,
  //   subject_id: this.subject_id,
  //   job_type_id: this.invoice_job_type_id,
  //   file_id: null,
  //   created_by: this.sessionUserId,
  // //  date_created: this.today,
  //   invoice_total: this.invoice_total,
  //   invoice_gst: this.invoice_tax,
  //   invoice_subtotal: this.invoice_subtotal,
  //   invoice_status_id: 1,
  //   invoice_payment_status_id: 1,
  //   invoice_communication_status_id: 1,
  //   from_brand_id: 94,
  // //  due_date: this.today,
  //   job_number: this.job_number,
  //         });




          // this.invoiceItem = [{
          //   invoice_number: this.subject_number,
          //   job_id: this.job_id,
          //   to_brand_id: this.brand_invoice_id,
          //   subject_id: this.subject_id,
          //   job_type_id: this.invoice_job_type_id,
          //   file_id: null,
          //   created_by: this.sessionUserId,
          //   date_created: this.valueDatePickerDate,
          //   invoice_total: this.invoice_total,
          //   invoice_gst: this.invoice_tax,
          //   invoice_subtotal: this.invoice_subtotal,
          //   invoice_status_id: '1',
          //   invoice_payment_status_id: '1',
          //   invoice_communication_status_id: '1',
          //   from_brand_id: 94,
          //   due_date: this.valueDatePickerDate,
          //   job_number: this.job_number,
          //   subject_number: this.subject_number,
          // }];

          // this.invoice_model = this.invoiceItem;




          this.workOrderItem = [{
            work_order_number: this.subject_number,
            job_id: this.job_id,
            to_brand_id: this.brand_invoice_id,
            subject_id: this.subject_id,
            job_type_id: this.invoice_job_type_id,
            file_id: null,
            created_by: this.sessionUserId,
            date_created: this.valueDatePickerDate,
            work_order_total: this.work_order_total,
            work_order_gst: this.work_order_tax,
            work_order_subtotal: this.work_order_subtotal,
            work_order_status_id: '1',
            work_order_payment_status_id: '1',
            work_order_communication_status_id: '1',
            from_brand_id: 94,
            due_date: this.valueDatePickerDate,
            job_number: this.job_number,
            subject_number: this.subject_number,
          }];

          this.work_order_model = this.workOrderItem;

          // :: In order to reflect the data changes on the template, you need to use detect changes, DID NOTHING!
          // ::: constructor(private cdr:ChangeDetectorRef) 
          // and apply the following once you push the data  
          // ::: this.cdr.detectChanges();
         
          // this.cdr.detectChanges(); // Switched off 15 feb 2023

          this.doCalculations();
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   private getInvoiceBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.invoice_brand = data;
        let res = data[0];
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }

  public getInvoiceAgentBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.agent_brand = data;
        let res = data[0];
        this.agent_full_name = res.name;
        this.work_order_model.agent_full_name = res.name;
        // this.invoiceForm.controls['agent_full_name'].setValue(this.agent_full_name); // sets the form value.
                // set the to_brand_id // so we dont have to change for evertyning
                this.work_order_model.to_brand_id = brand_id;
                // this.invoiceForm.controls['to_brand_id'].setValue(brand_id); // sets the form value.
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }

  
  private getOwnerBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.owner_brand = data;
        let res = data[0];
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }

  getInvoiceStatusAll(){
    this._demoService.getInvoiceStatusAll().subscribe(
      (data) => {
        this.invoice_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }

  getWorkOrderStatusAll(){
    this._demoService.getWorkOrderStatusAll().subscribe(
      (data) => {
        this.work_order_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }

  getInvoicePaymentStatusAll(){
    this._demoService.getInvoicePaymentStatusAll().subscribe(
      (data) => {
        this.invoice_payment_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


  getWorkOrderPaymentStatusAll(){
    this._demoService.getWorkOrderPaymentStatusAll().subscribe(
      (data) => {
        this.work_order_payment_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


  getInvoiceCommunicationStatusAll(){
    this._demoService.getInvoiceCommunicationStatusAll().subscribe(
      (data) => {
        this.invoice_communication_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }

  getWorkOrderCommunicationStatusAll(){
    this._demoService.getWorkOrderCommunicationStatusAll().subscribe(
      (data) => {
        this.work_order_communication_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }

  getSubjectBillingItems(subject_id) {
    // empty array of invoiceItemsList first
    this.invoiceItemsList = [];
    this._demoService.getSubjectBillingItems(subject_id).subscribe(
      data => { this.subject_billing_items = data;

      let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED'));

      let  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
       // Run the job data queries.

       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
  // do some totals and tax calculations.

 let tax_percent;
 let tax_value = 0;
  if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4 ) {
    tax_percent = 10;
    tax_value = (res.billing_task_fee / (100 / tax_percent));
        // fix for two decimaal precicion for myob
        let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
        tax_value = rounded_tax_value;
        // tax_value = (res.billing_task_fee / 11); // exclusive
      //  new_total = (+res.billing_task_fee + +tax_value); // + GST
      //  let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
      //  new_total = rounded_new_total;
  }
  if(res.myob_tax_code_id == 2 || res.myob_tax_code_id == 5 ) {
    tax_percent = 0;
    tax_value = 0;
  }
 
  
        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
       this.invoiceItemsList.push({
invoice_number: res.job_number,
billing_task_id: res.billing_task_id,
subject_billing_item_id: res.subject_billing_item_id,
billing_task_name: res.billing_task_name,
myob_tax_code_id: res.myob_tax_code_id,
myob_account_code_id: res.myob_account_code_id,
billing_task_fee: res.billing_task_fee,
billing_task_description: res.billing_task_description,
subject_id: res.subject_id,
subject_number: res.subject_number,
job_id: res.job_id,
job_number: res.job_number,
qty: 1,
unit_price: res.billing_task_fee,
tax: tax_value,
total: res.billing_task_fee,
      });


      this.invoiceItemsList = this.invoiceItemsList;

// this.invoiceItemsList = [{
//   invoice_number: res.job_number,
//   billing_task_id: res.billing_task_id,
//   subject_billing_item_id: res.subject_billing_item_id,
//   billing_task_name: res.billing_task_name,
//   myob_tax_code_id: res.myob_tax_code_id,
//   myob_account_code_id: res.myob_account_code_id,
//   billing_task_fee: res.billing_task_fee,
//   billing_task_description: res.billing_task_description,
//   subject_id: res.subject_id,
//   subject_number: res.subject_number,
//   job_id: res.job_id,
//   job_number: res.job_number,
//   qty: 1,
//   unit_price: res.billing_task_fee,
//   tax: tax_value,
//   total: res.billing_task_fee,
//         }];

    } // end for loop count

  // do some global calculations
// get sum of msgCount prop across all objects in array
// gets fee * qty adds them all up
// this.invoice_total = this.invoiceItemsList.reduce((acc, val) => acc += (val.billing_task_fee * val.qty ), 0);
this.doCalculations();

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getSubjectCostItems(subject_id) {
    // empty array of invoiceItemsList first
   // this.invoiceItemsList = [];
    this.workOrderItemsList = [];
    this._demoService.getSubjectCostItems(subject_id).subscribe(
      data => { this.subject_cost_items = data;

      let newArr = Object(data).filter((sbi)=>(sbi.work_order_status === 'NOT-APPLIED'));

      let  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
       // Run the job data queries.

       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
  // do some totals and tax calculations.

//  let tax_percent;
//  let tax_value = 0;
//  let new_total = 0; // + GST
//   if(res.myob_tax_code_id == 1) {
//     tax_percent = 10;
//     tax_value = (res.cost_task_fee / (100 / tax_percent));
//     new_total = (+res.cost_task_fee + +tax_value); // + GST
//         // fix for two decimaal precicion for myob
//         let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
//         tax_value = rounded_tax_value;
//         // tax_value = (res.billing_task_fee / 11); // exclusive
//        new_total = (+res.billing_task_fee + +tax_value); // + GST
//        let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
//        new_total = rounded_new_total;
//   }
//   if(res.myob_tax_code_id == 2) {
//     tax_percent = 0;
//     tax_value = 0;
//     new_total = res.cost_task_fee; // + GST
//   }
 


        // 2023 feb dont need anymore.
      //  let tax_percent;
      //  let tax_value = 0;
      //  let new_total = 0; // + GST
      //   if(res.myob_tax_code_id == 1) {
      //     tax_percent = 10;
      //     tax_value = (res.cost_task_fee / (100 / tax_percent));
      //     // new_total = (+res.cost_task_fee + +tax_value); // + GST
      //         // fix for two decimaal precicion for myob
      //   let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
      //         tax_value = rounded_tax_value;
      //         // tax_value = (res.billing_task_fee / 11); // exclusive
      //       //  new_total = (+res.billing_task_fee + +tax_value); // + GST
      //       //  let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
      //       //  new_total = rounded_new_total;
      //   }
      //   if(res.myob_tax_code_id == 2) {
      //     tax_percent = 0;
      //     tax_value = 0;
      //     new_total = res.cost_task_fee; // + GST
      // }
 



          // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
          this.workOrderItemsList.push({
            work_order_number: res.job_number,
            cost_task_id: res.cost_task_id,
            subject_cost_item_id: res.subject_cost_item_id,
            cost_task_name: res.cost_task_name,
            myob_tax_code_id: res.myob_tax_code_id,
            myob_account_code_id: res.myob_account_code_id,
            cost_task_fee: res.cost_task_fee,
            cost_task_description: res.cost_task_description,
            subject_id: res.subject_id,
            subject_number: res.subject_number,
            job_id: res.job_id,
            job_number: res.job_number,
            // new feb 2023
            qty: res.qty,
            unit_price: res.cost_task_fee,
            tax: res.tax,
            total: res.total,
            // total: new_total,
            agent_id: this.agent_id, // agent ID ionce selected in model.
            agent_full_name: this.agent_full_name // agent ID ionce selected in model.
                  });
  
//         // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
//        this.workOrderItemsList.push({
// work_order_number: res.job_number,
// cost_task_id: res.cost_task_id,
// subject_cost_item_id: res.subject_cost_item_id,
// cost_task_name: res.cost_task_name,
// myob_tax_code_id: res.myob_tax_code_id,
// myob_account_code_id: res.myob_account_code_id,
// cost_task_fee: res.cost_task_fee,
// cost_task_description: res.cost_task_description,
// subject_id: res.subject_id,
// subject_number: res.subject_number,
// job_id: res.job_id,
// job_number: res.job_number,
// qty: 1,
// unit_price: res.cost_task_fee,
// tax: tax_value,
// total: +res.cost_task_fee + +tax_value,
// // total: new_total,
// agent_id: this.agent_id, // agent ID ionce selected in model.
// agent_full_name: this.agent_full_name // agent ID ionce selected in model.
//       });


      this.workOrderItemsList = this.workOrderItemsList;

// this.invoiceItemsList = [{
//   invoice_number: res.job_number,
//   billing_task_id: res.billing_task_id,
//   subject_billing_item_id: res.subject_billing_item_id,
//   billing_task_name: res.billing_task_name,
//   myob_tax_code_id: res.myob_tax_code_id,
//   myob_account_code_id: res.myob_account_code_id,
//   billing_task_fee: res.billing_task_fee,
//   billing_task_description: res.billing_task_description,
//   subject_id: res.subject_id,
//   subject_number: res.subject_number,
//   job_id: res.job_id,
//   job_number: res.job_number,
//   qty: 1,
//   unit_price: res.billing_task_fee,
//   tax: tax_value,
//   total: res.billing_task_fee,
//         }];

    } // end for loop count

  // do some global calculations
// get sum of msgCount prop across all objects in array
// gets fee * qty adds them all up
// this.invoice_total = this.invoiceItemsList.reduce((acc, val) => acc += (val.billing_task_fee * val.qty ), 0);
this.doCalculations();

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  createSubjectInvoice(invoice_model) {

// invoice_model = [invoice_model]; // see if I can trick to make an object from form values missing brackets [{}]
// // :: need to add the [0] for #formname.value inserts.
// console.log(invoice_model);
//     this._demoService.createSubjectInvoice(invoice_model[0]).subscribe(
//        data => {  this.new_invoice_id = data;
//         let res = data[0];
//         // Run the insert of insert objects through a loop.
//         // let invoice_id = res.last_insert_id;

//         // console.log('InvoiceID: ' + invoice_id);

//         this.toastr.success('Invoice Entered');
//         this.closeParentModel.emit();
//       },
//        err => console.error(err),
//        // () => console.log('done loading Trace Types')
//      );



     this._demoService.createSubjectInvoice(invoice_model).subscribe(
      data => {  this.new_invoice_id = data; // this is the retuned json upon creation.

        let res = data[0];
                // Run the insert of insert objects through a loop.
                this.returned_invoice_id = this.new_invoice_id.last_insert_id;
                console.log(this.returned_invoice_id);

// now inset the items
let  count_of_items = Object.keys(this.invoiceItemsList).length;
  // need to do a loop of subject_billing items (.length)
  for(let i=0; i < count_of_items; i++) {
   let invoiceData = this.invoiceItemsList[i];
   // :: add the items
   this.addSubjectInvoiceItem(invoiceData, this.returned_invoice_id);
// :: TODO need to update subjectBillingItem, as status invoiced.
let invoice_status = "INVOICED";
this.updateSubjectBillingItemInvoiceStatus(invoice_status, invoiceData.subject_billing_item_id, this.returned_invoice_id, this.subject_number, invoice_model);
  } // end for

        this.toastr.success('Invoice Entered');
        this.closeParentModel.emit();
        this.refreshSujectWorkOrderPage(this.subject_id);
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
        this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
};



createSubjectWorkOrder(work_order_model) {
       this._demoService.createSubjectWorkOrder(work_order_model).subscribe(
        data => {  this.new_work_order_id = data; // this is the retuned json upon creation.
  
          let res = data[0];
                  // Run the insert of insert objects through a loop.
                  this.returned_work_order_id = this.new_work_order_id.last_insert_id;
                  console.log(this.returned_work_order_id);
  
  // now inset the items
  let  count_of_items = Object.keys(this.workOrderItemsList).length;
    // need to do a loop of subject_billing items (.length)
    for(let i=0; i < count_of_items; i++) {
     let workOrderData = this.workOrderItemsList[i];
     // :: add the items
     this.addSubjectWorkOrderItem(workOrderData, this.returned_work_order_id);
  // :: TODO need to update subjectBillingItem, as status invoiced.
  let work_order_status = "APPLIED";

  // tslint:disable-next-line:max-line-length
  this.updateSubjectCostItemWorkOrderStatusAgentID(work_order_status, workOrderData.subject_cost_item_id, this.returned_work_order_id, this.subject_number, this.agent_id, workOrderData);
    } // end for

          this.toastr.success('Work Order Entered');
          this.gfunc.insertLog_CreateWorkOrder(work_order_model);
          this.gfunc.insertNote_CreateSupplierInvoice(work_order_model);
          this.closeParentModel.emit();
          this.refreshSujectWorkOrderPage(this.subject_id);
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
         return true;
        },
        error => {
          console.error(error);
          this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
   )
  };
  


   addSubjectInvoiceItem(model, invoice_id){
    this._demoService.addSubjectInvoiceItem(model, invoice_id).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   }



   addSubjectWorkOrderItem(model, invoice_id){
    this._demoService.addSubjectWorkOrderItem(model, invoice_id).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   }



   updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id,invoice_number, invoice_model){
    this._demoService.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   };




   

   updateSubjectCostItemWorkOrderStatusAgentID(work_order_status, subject_cost_item_id, work_order_id, work_order_number, agent_id, work_order_model){
    this._demoService.updateSubjectCostItemWorkOrderStatusAgentID(work_order_status, subject_cost_item_id, work_order_id, work_order_number, agent_id, work_order_model).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   };


   

   updateSubjectCostItemWorkOrderStatus(work_order_status, subject_cost_item_id, work_order_id, work_order_number){
    this._demoService.updateSubjectCostItemWorkOrderStatus(work_order_status, subject_cost_item_id, work_order_id, work_order_number).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   };

doCalculations(){
  this.work_order_tax = this.workOrderItemsList.reduce((a, b) => a + Number(b.tax), 0); // now calculates
  
  this.work_order_model.work_order_gst = this.work_order_tax;

  this.work_order_total = this.workOrderItemsList.reduce((a, b) => a += (b.cost_task_fee * b.qty), 0);
  this.work_order_model.work_order_total = this.work_order_total + this.work_order_tax; // added tax

  // this.work_order_subtotal = (this.work_order_model.work_order_total - this.work_order_tax); // dont take the tax! for gst
  this.work_order_subtotal = (this.work_order_model.work_order_total); // Dont take the tax!
  this.work_order_model.work_order_subtotal = this.work_order_subtotal;

  this.work_order_model = this.workOrderItem;

}


// can also run from a child component.
doCalculations_() {
  // this.toastr.info('Calculating...');
  this.work_order_total = this.workOrderItemsList.reduce((a, b) => a += (b.cost_task_fee * b.qty), 0);
  this.work_order_model.work_order_total = this.work_order_total;
 // this.work_order_tax = (this.work_order_model.work_order_total / (100 / 10));
// this.work_order_tax = this.work_orderItemsList.reduce((a, b) => a += (b.tax * b.qty), 0); // now calculates
 this.work_order_tax = this.workOrderItemsList.reduce((a, b) => a += (b.tax), 0); // now calculates
  this.work_order_model.work_order_gst = this.work_order_tax;
  this.work_order_subtotal = (this.work_order_model.work_order_total - this.work_order_tax);
  this.work_order_model.work_order_subtotal = this.work_order_subtotal;

  this.work_order_model = this.workOrderItem;
 // alert('test');
}





// can also run from a child component.
doCalculations__() {

  this.work_order_tax = this.workOrderItemsList.reduce((a, b) => a += (b.tax), 0); // now calculates
  this.work_order_model.work_order_gst = this.work_order_tax;

  // this.toastr.info('Calculating...');
  this.work_order_total = this.workOrderItemsList.reduce((a, b) => a += (b.cost_task_fee * b.qty), 0);
  this.work_order_model.work_order_total = this.work_order_total + this.work_order_tax;
 // this.work_order_tax = (this.work_order_model.work_order_total / (100 / 10));
// this.work_order_tax = this.work_orderItemsList.reduce((a, b) => a += (b.tax * b.qty), 0); // now calculates

  // this.work_order_subtotal = (this.work_order_model.work_order_total - this.work_order_tax);
  this.work_order_subtotal = (this.work_order_model.work_order_total); // Dont take the tax!
  this.work_order_model.work_order_subtotal = this.work_order_subtotal;

  this.work_order_model = this.workOrderItem;
 // alert('test');
}




toggleShow(index) {
 // this.isShowEdit = ! this.isShowEdit;
// if (this.isShow === index){
// this.isShow = '';
// }else{
//   this.isShow = index; // sets to the array row.d
// }
this.isShow = index; // sets to the array row.d

  }

  toggleHide(index) {
 // this.isShowEdit = ! this.isShowEdit;
// if (this.isShow === index){
// this.isShow = '';
// }else{
//   this.isShow = index; // sets to the array row.d
// }
this.isShow = index; // sets to the array row.d

  }



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}



// :: Parent / Child modal test
closeParentModel2() {
 //  alert('parent component function.');
   this.modalRef.hide();
// now refresh the invoice items list from the new items.
    // empty your array first
    this.invoiceItemsList.length = 0;
this.getSubjectBillingItems(this.subject_id);


 // this.closeParentModel.emit(); // ?shuts invoice window
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};

RemoveElementFromObjectArray(key: number) {
  let data = this.workOrderItemsList;
      // data.forEach((value, index) => {
      //   if ( value.subject_billing_item_id === key) {
      //     this.row_data.splice(index, 1); }
      // });
      data.forEach((value,index)=>{
        if(value.subject_cost_item_id==key) data.splice(index,1);
    });

// do I need to refesh like adding?
this.doCalculations();

     };

     refreshWorkOrderItemsBelow() {
      console.log('Reloading Items');
 // this.getSubjectBillingItems(this.subject_id);
 this.getSubjectCostItems(this.subject_id);
 this.getJobSubject(this.subject_id);
 this.getJob(this.job_id);
 this.getSubjectAgentBrandsAssigned(this.subject_id);
 // this.getInvoiceStatusAll();
 // this.getInvoicePaymentStatusAll();
 // this.getInvoiceCommunicationStatusAll();
 this.getWorkOrderStatusAll();
 this.getWorkOrderPaymentStatusAll();
 this.getWorkOrderCommunicationStatusAll();
    }


     refreshSujectWorkOrderPage(subject_id){
      // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
                    // this.router.navigate(['/admin/jobs/subject/cost/' + subject_id + '']));
                    this.gfunc.globalJobSubjectCostViewSkipRoute(subject_id);
    
    }

    //  refreshSujectInvoicePage(subject_id){
    //   this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    //                 this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));
    
    // }


    getSubjectAgentBrandsAssigned(subject_id) {
      this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
        (data) => {
          this.assignedBrandList = data;
    
        //  this.allEmailRecipients = data;
        },
        (err) => console.error(err),
        // () => console.log('Loaded Assigned Agents Loaded.')
      );
    }



    deleteSubjectWorkOrderItem(model, work_order_item_id){
      if (confirm('Are you sure you want to delete this item from the work order. It will still appearr in cost items, yet to be applied.')) {
        this._demoService.deleteSubjectWorkOrderItem(model, work_order_item_id).subscribe(
           data => {
            // update the status of subjectbillingItems
            let work_order_status = 'NOT-APPLIED';
            let work_order_id = 0;
            let work_order_number = 0;
            
            let subject_cost_item_id = model.subject_cost_item_id;
            this.updateSubjectCostItemWorkOrderStatus(work_order_status, subject_cost_item_id, work_order_id, work_order_number);
            // refresh the list
           ////  this.getSubjectBillingItems(this.invoice_id); // seemed to remove all items from the list??? upon delete when they are still in the database...
            // refresh the bottom widow of sibjectBillingItems from Modal
            this.refreshSujectWorkOrderPage(this.subject_id);
            /// :: lets do a refresh of the invoice data to refresh the invoice_items_list.
            // this.getWorkOrderItems(this.work_order_id);
             return true;
           },
           error => {
             console.error('Error deleting!');
             console.error(error);
             // return Observable.throw(error);
           }
        );
    }
  };

    getWorkOrderItems(work_order_id){
      this._demoService.getSubjectWorkOrderItems(work_order_id).subscribe(
        (data) => {
          this.workOrderItemsList = data;
          let res = data[0];
  
          this.work_order_item_model = this.workOrderItemsList;
          this.getWorkOrderAgentBrand(res.agent_id);
          this.doCalculations();
        },
        (err) => console.error(err),
       // () => console.log('Brand Loaded.')
      ) };
   
      public getWorkOrderAgentBrand(agent_id) {
        this._demoService.getBrandById(agent_id).subscribe(
          (data) => {
            this.agent_brand = data;
            let res = data[0];
            // this.agent_full_name = this.agent_brand[0].agent_full_name;
            // this.work_order_model.agent_full_name = this.agent_brand[0].agent_full_name;
            this.invoiceForm.controls['agent_full_name'].setValue(res.name); // sets the form value.
            // set the to_brand_id // so we dont have to change for evertyning
            this.work_order_model.to_brand_id = agent_id;
            this.invoiceForm.controls['to_brand_id'].setValue(agent_id); // sets the form value.
    
            this.selected_agent_id = agent_id;
    
          },
          (err) => console.error(err),
          () => console.log('Agent Loaded.')
        );
      }



     // Position Drop down menu button in top action in open
    // To open popup in particular position.
    public onOpen (args: OpenCloseMenuEventArgs) {
      args.element.parentElement.style.top = this.dropdownbutton.element.getBoundingClientRect().top - args.element.parentElement.offsetHeight +'px';
   } 

  
  }

// Allows formatting of dates etc...
export class DatePipeComponent {
  today: number = Date.now();
  fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
// tslint:disable-next-line:eofline
}